import type { ComponentProps } from 'react';
import * as SwitchPrimitive from '@radix-ui/react-switch';
import { cn } from '@shared/lib';

export type SwitchProps = ComponentProps<typeof SwitchPrimitive.Root>;

/**
 * On/off toggle built on Radix. Greens on when checked. **A11y:** `switch` role,
 * Space/Enter to toggle; label it with an adjacent `Label` (`htmlFor` → the switch `id`).
 */
export function Switch({ className, ...props }: SwitchProps) {
  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      className={cn(
        'peer inline-flex h-7 w-15 shrink-0 items-center rounded-full p-0.5 transition-colors',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-bg',
        'disabled:cursor-not-allowed disabled:opacity-50',
        'data-[state=unchecked]:bg-border data-[state=checked]:bg-success',
        className,
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb
        className={cn(
          'pointer-events-none block h-6 w-8.5 translate-x-0 rounded-full bg-white shadow-card transition-transform',
          'data-[state=checked]:translate-x-[1.35rem]',
        )}
      />
    </SwitchPrimitive.Root>
  );
}
